<template>
  <el-form ref="formRef" :model="localForm" :rules="rules" label-width="110px" class="sku-form">
    <el-card class="sku-form__section" shadow="never">
      <div slot="header" class="sku-form__title">基础信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="SKU 名称" prop="sku_name">
            <el-input v-model="localForm.sku_name" maxlength="100" clearable placeholder="例如 Windows 单设备一个月"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU key" prop="sku_key">
            <el-input v-model="localForm.sku_key" maxlength="100" clearable placeholder="例如 win32_30d_1dev"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="套餐" prop="plan_id">
            <el-select v-model="localForm.plan_id" filterable placeholder="选择套餐" class="sku-form__full">
              <el-option
                v-for="plan in plans"
                :key="plan.id"
                :label="plan.plan_name + ' / ' + plan.plan_key"
                :value="plan.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用状态" prop="enabled">
            <el-switch
              v-model="localForm.enabled"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="授权模式" prop="plan_mode">
            <el-radio-group v-model="localForm.plan_mode">
              <el-radio-button label="dynamic">动态</el-radio-button>
              <el-radio-button label="snapshot">快照</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU 类型" prop="sku_type">
            <el-radio-group v-model="localForm.sku_type">
              <el-radio-button label="normal">标准</el-radio-button>
              <el-radio-button label="custom">自定义</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="sku-form__section" shadow="never">
      <div slot="header" class="sku-form__title">授权规格</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="平台" prop="platform">
            <el-select v-model="localForm.platform" class="sku-form__full">
              <el-option
                v-for="item in platformOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="时长" prop="time_limit">
            <el-select
              v-model="localForm.time_limit"
              allow-create
              filterable
              default-first-option
              placeholder="选择或输入天数"
              class="sku-form__full">
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备数" prop="allow_device_num">
            <el-input-number v-model="localForm.allow_device_num" :min="1" :max="1000" class="sku-form__full"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="sku-form__section" shadow="never">
      <div slot="header" class="sku-form__title">价格与排序</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="套餐价格" prop="price">
            <el-input-number v-model="localForm.price" :min="0" :max="999999" :precision="2" :step="1" class="sku-form__full"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单设备价格" prop="one_device_price">
            <el-input-number v-model="localForm.one_device_price" :min="0" :max="999999" :precision="2" :step="1" class="sku-form__full"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="localForm.sort" :min="0" :max="999999" class="sku-form__full"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="comment">
        <el-input
          v-model="localForm.comment"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          maxlength="500"
          show-word-limit
          placeholder="可填写内部备注">
        </el-input>
      </el-form-item>
    </el-card>
  </el-form>
</template>

<script>
export default {
  name: 'SkuForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    plans: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    const validateSkuKey = (rule, value, callback) => {
      if (!/^[a-zA-Z0-9][a-zA-Z0-9_-]{1,99}$/.test(String(value || ''))) {
        callback(new Error('只能使用字母、数字、下划线和中划线，长度 2-100'))
        return
      }
      callback()
    }
    const validateTimeLimit = (rule, value, callback) => {
      if (value === '' || value === null || Number.isNaN(Number(value)) || Number(value) < 0) {
        callback(new Error('请输入不小于 0 的天数'))
        return
      }
      callback()
    }
    return {
      localForm: this.normalizeForm(this.value),
      rules: {
        sku_name: [{ required: true, message: '请输入 SKU 名称', trigger: 'blur' }],
        sku_key: [
          { required: true, message: '请输入 SKU key', trigger: 'blur' },
          { validator: validateSkuKey, trigger: 'blur' }
        ],
        plan_id: [{ required: true, message: '请选择套餐', trigger: 'change' }],
        platform: [{ required: true, message: '请选择平台', trigger: 'change' }],
        time_limit: [{ validator: validateTimeLimit, trigger: 'change' }],
        allow_device_num: [{ required: true, message: '请输入设备数', trigger: 'change' }]
      },
      platformOptions: [
        { name: 'Windows', value: 'win32' },
        { name: 'macOS', value: 'darwin' },
        { name: 'Android', value: 'android' },
        { name: 'iOS', value: 'ios' },
        { name: '全平台', value: 'all' }
      ],
      timeOptions: [
        { name: '永久', value: 0 },
        { name: '一年 / 365 天', value: 365 },
        { name: '半年 / 180 天', value: 180 },
        { name: '季度 / 120 天', value: 120 },
        { name: '一个月 / 30 天', value: 30 },
        { name: '7 天', value: 7 },
        { name: '1 天', value: 1 },
        { name: '12 小时 / 0.5 天', value: 0.5 }
      ]
    }
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.localForm = this.normalizeForm(val)
      }
    }
  },
  methods: {
    validate(callback) {
      this.$refs.formRef.validate(callback)
    },
    getForm() {
      const data = Object.assign({}, this.localForm)
      data.time_limit = Number(data.time_limit)
      data.allow_device_num = Number(data.allow_device_num)
      data.price = Number(data.price || 0)
      data.one_device_price = Number(data.one_device_price || 0)
      data.sort = Number(data.sort || 0)
      data.enabled = Number(data.enabled) === 1 ? 1 : 0
      return data
    },
    normalizeForm(value) {
      const form = Object.assign({
        id: 0,
        sku_key: '',
        sku_name: '',
        plan_id: '',
        plan_mode: 'dynamic',
        sku_type: 'normal',
        platform: 'win32',
        time_limit: 365,
        allow_device_num: 1,
        price: 0,
        one_device_price: 0,
        enabled: 1,
        sort: 0,
        comment: ''
      }, value || {})
      form.id = Number(form.id || 0)
      form.plan_id = form.plan_id === '' ? '' : Number(form.plan_id)
      form.time_limit = Number(form.time_limit || 0)
      form.allow_device_num = Number(form.allow_device_num || 1)
      form.price = Number(form.price || 0)
      form.one_device_price = Number(form.one_device_price || 0)
      form.enabled = Number(form.enabled) === 1 ? 1 : 0
      form.sort = Number(form.sort || 0)
      return form
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-form {
  max-width: 1180px;
}

.sku-form__section {
  border-radius: 4px;
  margin-bottom: 12px;
}

.sku-form__title {
  color: #222;
  font-weight: 600;
}

.sku-form__full {
  width: 100%;
}
</style>
